module.exports = __webpack_public_path__ + "img/logo.48975c9e.png";